<div class="c-container" #ccontainer [ngStyle]="{padding: 'calc(' + marqueurSize + 'px / 2)'}">
  <ng-content></ng-content>
  <ng-container *ngFor="let dragPosition of initialDragPositions; let i = index">
    <ng-container *ngIf="cannotMoveMarkers; else MovableMarker">
      <div
        class="c-marqueur c-marker-unmovable"
        [ngClass]="{'c-marker-clickable': cannotMoveMarkers && canClickMarkers, 'c-marqueur-valide': cannotMoveMarkers && canClickMarkers && marqueursForms && (marqueursForms | marqueurformValidity:i:'valid'), 'c-marqueur-invalide': cannotMoveMarkers && canClickMarkers && marqueursForms && (marqueursForms | marqueurformValidity:i:'invalid')}"
        [ngStyle]="{
          height: marqueurSize + 'px',
          width: marqueurSize + 'px',
          transform: 'translate3d(' + dragPosition.x + 'px, ' + dragPosition.y + 'px, 0px)',
          'font-size': 'calc(' + marqueurSize + 'px * 3 / ' + (dragPosition.label.length | dynamicMarqueurFontSize) + ')',
        }"
        (click)="onMarkerClick(i)"
      >
      {{ dragPosition.label }}
      </div>
    </ng-container>
    <ng-template #MovableMarker>
      <div
        class="c-marqueur"
        cdkDrag cdkDragBoundary=".c-container"
        [ngStyle]="{
          height: marqueurSize + 'px',
          width: marqueurSize + 'px',
          transform: 'translate3d(' + dragPosition.x + 'px, ' + dragPosition.y + 'px, 0px)',
          'font-size': 'calc(' + marqueurSize + 'px * 3 / ' + (dragPosition.label.length | dynamicMarqueurFontSize) + ')',
        }"
        (cdkDragEnded)="drop(dragPosition, i, $event)"
      >
        {{ dragPosition.label }}
      </div>
    </ng-template>
  </ng-container>
</div>
